import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { Webhook, WebhookHistory } from "../../entities/webhook";
import { createWebhook, deleteWebhook, getWebhook, getWebhookHistory, getWebhooks, updateWebhook } from "./thunks";
import { RootState } from "..";
import { ResponseMetaData } from "../../entities/global";

interface WebhookState {
  loading: boolean;
  saveLoading: boolean;
  webhooks: Webhook[];
  history: WebhookHistory[];
  webhook?: Webhook;
  webhookLoading: boolean;
  historyMeta: ResponseMetaData;
  meta: ResponseMetaData;
}

const initialState: WebhookState = {
  loading: false,
  saveLoading: false,
  webhookLoading: false,
  webhooks: [],
  history: [],
  historyMeta: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  },
  meta: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  },
};

// const addLoadingCases = (
//   builder: ActionReducerMapBuilder<WheelState>,
//   action: any
// ) => {
//   builder.addCase(action.pending, (state: WheelState) => {
//     state.saveLoading = true;
//   });

//   builder.addCase(action.fulfilled, (state: WheelState) => {
//     state.saveLoading = false;
//   });
// };

export const webhookSlice = createSlice({
  name: "bonus",
  initialState,
  reducers: {
    clearWebhookHistory: (state: Draft<WebhookState>) => {
      state.history = [];
      state.webhook = undefined;
    },
    setWebhook: (
      state: Draft<WebhookState>,
      action: PayloadAction<Webhook>
    ) => {
      state.webhook = action.payload;
    },
  },
  extraReducers: (builder) => {
    // getWebhooks
    builder.addCase(getWebhooks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWebhooks.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.webhooks = data;
      state.meta = meta;
      state.loading = false;
    });
    // getWebhookHistory
    builder.addCase(getWebhookHistory.pending, (state) => {
      state.history = [];
      state.loading = true;
    });
    builder.addCase(getWebhookHistory.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.history = data;
      state.historyMeta = meta;
      state.loading = false;
    });
    builder.addCase(getWebhookHistory.rejected, (state) => {
      state.loading = false;
    });
    // getWebhook
    builder.addCase(getWebhook.pending, (state) => {
      state.webhookLoading = true;
    });
    builder.addCase(getWebhook.fulfilled, (state, action) => {
      state.webhook = action.payload;
      state.webhookLoading = false;
    });
    // createWebhook
    builder.addCase(createWebhook.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(createWebhook.fulfilled, (state, action) => {
      state.saveLoading = false;
      if (action.payload) state.webhooks = [action.payload, ...state.webhooks];
    });
    builder.addCase(createWebhook.rejected, (state) => {
      state.saveLoading = false;
    });
    // updateWebhook
    builder.addCase(updateWebhook.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(updateWebhook.fulfilled, (state, action) => {
      state.saveLoading = false;
      if (action.payload) {
        state.webhooks = state.webhooks.map((w) =>
          w.id === action.payload!.id ? action.payload! : w
        );
      }
    });
    builder.addCase(updateWebhook.rejected, (state) => {
      state.saveLoading = false;
    });
    // deleteWebhook
    builder.addCase(deleteWebhook.fulfilled, (state, action) => {
      if (action.payload) {
        state.webhooks = state.webhooks.filter((w) => w.id !== action.payload);
      }
    });
  },
});

export const { clearWebhookHistory, setWebhook } = webhookSlice.actions;

export const selectWebhookState = (state: RootState) => state.webhook;

export default webhookSlice.reducer;
